import { Component, inject, OnInit } from '@angular/core';
import { ConfiguracionService } from '../../../../services/configuracion.service';
import { Configuracion } from '../../../../models/Util';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { DlgEditarParametroConfiguracionComponent } from '../../../../commons/dlg-editar-parametro-configuracion/dlg-editar-parametro-configuracion.component';
import { MatToolbarModule } from "@angular/material/toolbar";
import { AppTitleService } from '../../../../services/app-title.service';

@Component({
    selector: 'app-parametros-configuracion',
    imports: [
    MatTableModule,
    MatToolbarModule
],
    templateUrl: './parametros-configuracion.component.html',
    styleUrl: './parametros-configuracion.component.scss'
})
export class ParametrosConfiguracionComponent implements OnInit {
  parametrosConfiguracion: Configuracion[] = []

  displayedColumns: string[] = ['codigo', 'descripcion', 'texto', 'numero'];
  dataSource = new MatTableDataSource<Configuracion>([])

  constructor(
    private configuracionService: ConfiguracionService,
    private _sanitizer: DomSanitizer,
    public dlg: MatDialog,
  ) { 
    inject(AppTitleService).setTitle("Par\xf3metros de configuraci\xf3n");
  }

  ngOnInit(): void {
    this.fetchListParametrosConfiguracion()
  }

  fetchListParametrosConfiguracion() {
    this.configuracionService.listConfigurationParameters().subscribe({
      next: (response) => {
        this.parametrosConfiguracion = response
        this.dataSource!.data = this.parametrosConfiguracion
      }
    })
  }

  clickedRow(row: Configuracion) {
    const dialogRef = this.dlg.open(DlgEditarParametroConfiguracionComponent, {
      maxWidth: "50vw",
      width: "500px",
      data: row
    })
    dialogRef.afterClosed().subscribe((result: Configuracion | null) => {
      if (result) {
        this.fetchListParametrosConfiguracion()
      }
    });
  }

  isBase64(texto: string) {
    if (!texto) {
      return true
    }
    if (!texto.includes("base64")) {
      return true
    }
    return false
  }

  renderBase64(texto: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl("data:image/jpg;base64" + texto)
  }
}
